export default {
  getProductsMutation(state, data) {
    state.products = data.data
    state.productMeta = data.meta
  },
  searchProductByBarcodeMutation(state, data) {
    state.product = data
  },
}
